import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {Calendar} from "primereact/calendar";
import {Tag} from "primereact/tag";
import {Checkbox} from "primereact/checkbox";
import Message from "../Helpers/Message.js";
import {fetch_url_post,format_date,focus_next,filter_active_inactive} from "../../Sources/js/app.js";

let oper="";

let currentDate=new Date();
let currentYear=currentDate.getFullYear();
let yearsList=[];

for(let i=-2;i<2;i++) {
	let cYear={
		label: currentYear+i,
		value: currentYear+i
	}
	yearsList.push(cYear);
} 

let defaultInputValues={
	id: null,
	provider_id: 0,
	observations: "",
	no: "",
	agreement_start_date: currentDate,
	filter_providers: "",
	agreement_stop_date: currentDate,
	active: 1,
	agreement_date: currentDate,
	filter_active: 1,
	filter_inactive: 0,
	seap_no: "",
	replace_in_template: 0,
};

let defaultInputValuesProducts={
	id: null,
	product_id: 0,
	product_mu_id: "",
	quantity: "",
	filter_products: "",
	product_type_id: 0,
	filter_product_type: "",
	observations: "",
	unitary_price: 0,
};

let defaultDataValues={
	agreementsList: [],
	providersList: [],
	agreementProductsList: [],
	productsList: [],
	MUsList:[],
	productsTypesList: [],
	frameAgreementsList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openListProducts: false,
	titleListProducts: "",
	openAddEditProduct: false,
	titleAddEditProduct: "",
	openClone: false,
	titleClone: "",
	openChangeActive: false,
	titleChangeActive: "",
	openFrameAgreements: false,
	titleFrameAgreements: "",
};

let activeList=[
	{label: "DA",value: 1},
	{label: "NU",value: 0},
];

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let currentAgreement={};

const SubAgreements = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.typeId?props.typeId:null);
	let ct=1;

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [agreementsList, setAgreementsList] = useState([]);
	const [inputValuesProducts, setInputValuesProducts] = useState(defaultInputValuesProducts);
	const [agreementProductsList, setAgreementProductsList] = useState([]);
	const [productsList, setProductsList] = useState([]);
	const [tableQuantities, setTableQuantities] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="active") {
			if((value===0)&&(inputValues.id)) {
				setDialogValues({...dialogValues,openChangeActive: true,titleChangeActive: "Atentie"});
			}
		}
		if(name==="filter_providers") {
			setAgreementsList(dataValues.agreementsList.filter((agreement)=>((agreement.provider_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value===""))
														.filter((agreement)=>(filter_active_inactive(agreement,inputValues.filter_active,inputValues.filter_inactive)))
			);
		}
		if((name==="filter_active")||(name==="filter_inactive")) {
			setInputValues({...inputValues,[name]:(evt.checked?1:0)});
			if(name==="filter_active") {
				setAgreementsList(dataValues.agreementsList.filter((agreement)=>((agreement.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1))||(inputValues.filter_providers===""))
															.filter((agreement)=>(filter_active_inactive(agreement,(evt.checked?1:0),inputValues.filter_inactive)))
				);
			}else{
				setAgreementsList(dataValues.agreementsList.filter((agreement)=>((agreement.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1))||(inputValues.filter_providers===""))
															.filter((agreement)=>(filter_active_inactive(agreement,inputValues.filter_active,(evt.checked?1:0))))
				);				
			}
			state_update=1;
		}
		if(name==="replace_in_template") {
			setInputValues({...inputValues,[name]:(evt.checked?1:0)});
			state_update=1;
		}
		if(!state_update) {
			setInputValues({...inputValues,[name]:value});
		}
	}

	const handleChangeProducts = evt => {
		const {name, value} = evt.target;
		let state_update=0;
		if(name==="product_id") {
			let tmp=dataValues.productsList.filter((product)=>(product.id===value));
			setInputValuesProducts({...inputValuesProducts,product_mu_id:tmp[0].product_mu_id,
															product_id:value
			});
			state_update=1;
			let found=false;
			if(dataValues.agreementProductsList.length>0) {
				dataValues.agreementProductsList.forEach(element => {
					if((value===element.product_id)&&(tmp[0].product_mu_id===element.product_mu_id)) {
						found=true;
					}
				});
			}
			tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="product_mu_id") {
			let found=false;
			if(dataValues.agreementProductsList.length>0) {
				dataValues.agreementProductsList.forEach(element => {
					if((value===element.product_mu_id)&&(inputValuesProducts.product_id===element.product_id)) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Exista deja un produs similar adaugat!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_products") {
			setAgreementProductsList(dataValues.agreementProductsList.filter((product)=>((product.product_name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		if(name==="product_type_id") {
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if(name==="filter_product_type") {
			setAgreementProductsList(dataValues.agreementProductsList.filter((product)=>((product.product_type_id===value)||(value==="")||(!value))));
		}
		if((name==="unitary_price")||(name==="min_quantity")||(name==="max_quantity")) {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
		}
		if(!state_update) {
			setInputValuesProducts({...inputValuesProducts,[name]:value});
		}
	}

	const handleChangeTable = (evt,id) => {
		const {name, value} = evt.target;
		if(name==="quantity_table") {
			if(!evt.target.validity.valid) {
				setMessageText("Eroare: Sunt permise numai cifre!");							
				return false;
			}
			let tmp={...tableQuantities};
			tmp[id]=value;
			setTableQuantities(tmp);
		}
	}

	const handleFocusTable = (evt) => {
		if(evt.keyCode===13) {
			focus_next(evt);
		}
	}

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			let tmp={...defaultInputValues};
			tmp.filter_providers=inputValues.filter_providers;
			tmp.filter_active=inputValues.filter_active;			
			tmp.filter_inactive=inputValues.filter_inactive;			
			setInputValues(tmp);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare contract subsecvent"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			let tmp={...elementData};
			tmp.filter_providers=inputValues.filter_providers;
			tmp.filter_active=inputValues.filter_active;			
			tmp.filter_inactive=inputValues.filter_inactive;			
			let tmp_data=elementData.agreement_date_parsed.split("-");
			tmp.agreement_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			tmp_data=elementData.agreement_start_date_parsed.split("-");
			tmp.agreement_start_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			tmp_data=elementData.agreement_stop_date_parsed.split("-");
			tmp.agreement_stop_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			setInputValues(tmp);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare contract subsecvent "+elementData.provider_name});
			setInputError(defaultInputError);
		}
		if(what==="delete") {
			let url="deleteSubAgreement";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValues.no) {
				setMessageText("Eroare: Completati numarul contractului!");				
				document.getElementById("no").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.agreement_start_date) {
				setMessageText("Eroare: Selectati data start pentru contract!");				
				document.getElementById("agreement_start_date").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.agreement_stop_date) {
				setMessageText("Eroare: Selectati data stop pentru contract!");				
				document.getElementById("agreement_stop_date").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.provider_id) {
				setMessageText("Eroare: Selectati furnizorul din lista!");				
				document.getElementById("provider_id").classList.add("required_input_error");
				return false;
			}
			let url="saveSubAgreement";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			data.agreement_start_date=format_date(data.agreement_start_date,"yyyy-mm-dd");
			data.agreement_stop_date=format_date(data.agreement_stop_date,"yyyy-mm-dd");
			data.agreement_date=format_date(data.agreement_date,"yyyy-mm-dd");
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_products") {
			let url="getSubAgreementProducts";
			url+="?session_id="+props.session.sessId;
			oper="list_products";
			let data={
				sub_agreements_id: elementData.id,
			};
			currentAgreement=elementData;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="add_product") {
			setProductsList(dataValues.productsList);
			setInputValuesProducts(defaultInputValuesProducts);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Adaugare produs nou"});
			setInputError(defaultInputError);
		}
		if(what==="edit_product") {
			elementData.filter_products=inputValuesProducts.filter_products;
			elementData.filter_product_type=inputValuesProducts.filter_product_type;
			setProductsList(dataValues.productsList.filter((product)=>((product.product_type_id===elementData.product_type_id)||(elementData.product_type_id==="")||(!elementData.product_type_id))));			
			setInputValuesProducts(elementData);
			setDialogValues({...dialogValues,openAddEditProduct: true,titleAddEditProduct: "Editare produs "});
			setInputError(defaultInputError);
		}
		if(what==="delete_product") {
			let url="deleteSubAgreementProduct";
			url+="?session_id="+props.session.sessId;
			oper="delete_product";
			let data={
				id: elementData.id,
				sub_agreements_id: currentAgreement.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_product") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValuesProducts.product_id) {
				setMessageText("Eroare: Alegeti un produs din lista!");				
				document.getElementById("product_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.product_mu_id) {
				setMessageText("Eroare: Alegeti o unitate de masura!");				
				document.getElementById("product_mu_id").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.quantity) {
				setMessageText("Eroare: Completati cantitatea!");				
				document.getElementById("quantity").classList.add("required_input_error");
				return false;
			}
			if(!inputValuesProducts.unitary_price) {
				setMessageText("Eroare: Completati pretul unitar!");				
				document.getElementById("unitary_price").classList.add("required_input_error");
				return false;
			}
			let url="saveSubAgreementProduct";
			url+="?session_id="+props.session.sessId;
			oper="save_product";
			let data={...inputValuesProducts};
			data.sub_agreements_id=currentAgreement.id;
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="clone") {
			let tmp={...elementData};
			tmp.filter_providers=inputValues.filter_providers;
			tmp.filter_active=inputValues.filter_active;			
			tmp.filter_inactive=inputValues.filter_inactive;			
			let tmp_data=elementData.agreement_date_parsed.split("-");
			tmp.agreement_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			tmp_data=elementData.agreement_start_date_parsed.split("-");
			tmp.agreement_start_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			tmp_data=elementData.agreement_stop_date_parsed.split("-");
			tmp.agreement_stop_date=new Date(tmp_data[2]+"-"+tmp_data[1]+"-"+tmp_data[0]);
			tmp.no="";
			setInputValues(tmp);
			setDialogValues({...dialogValues,openClone: true,titleClone: "Clonare contract subsecvent "+elementData.provider_name});
			setInputError(defaultInputError);
		}
		if(what==="save_clone") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(!inputValues.no) {
				setMessageText("Eroare: Completati numarul contractului!");				
				document.getElementById("no").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.agreement_date) {
				setMessageText("Eroare: Selectati data contractului!");				
				document.getElementById("agreement_date").classList.add("required_input_error");
				return false;
			}
			if(!inputValues.provider_id) {
				setMessageText("Eroare: Selectati furnizorul din lista!");				
				document.getElementById("provider_id").classList.add("required_input_error");
				return false;
			}
			let url="cloneSubAgreement";
			url+="?session_id="+props.session.sessId;
			oper="save_clone";
			let data={...inputValues};
			data.agreement_date=format_date(data.agreement_date,"yyyy-mm-dd");
			data.agreement_start_date=format_date(data.agreement_start_date,"yyyy-mm-dd");
			data.agreement_stop_date=format_date(data.agreement_stop_date,"yyyy-mm-dd");
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_quantities") {
			let url="saveQuantitiesSubAgreement";
			url+="?session_id="+props.session.sessId;
			oper="save_quantities";
			let tmp=[];
			Object.entries(tableQuantities).forEach(([id,quantity]) => {
				let c_quantity={};
				c_quantity.id=id;
				c_quantity.quantity=quantity;
				tmp.push(c_quantity);
			});
			let data={
				quantities: tmp,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="list_frame_agreements") {
			let url="getFrameAgreementsByProvider";
			url+="?session_id="+props.session.sessId;
			oper="list_frame_agreements";
			let data={
				provider_id: currentAgreement.provider_id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="get_products_from_sub_agreement") {
			let url="getProductsFromFrameAgreement";
			url+="?session_id="+props.session.sessId;
			oper="get_products_from_sub_agreement";
			let data={
				frame_agreements_id: elementData.id,
				sub_agreements_id: currentAgreement.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);			
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Eroare: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")||(oper==="save_clone")) {
			if(oper==="get") {
				setDataValues({...dataValues,
											agreementsList:(result.agreementsList?result.agreementsList:[]),
											providersList:(result.providersList?result.providersList:[]),
											productsList:(result.productsList?result.productsList:[]),
											MUsList:(result.MUsList?result.MUsList:[]),
											productsTypesList:(result.productsTypesList?result.productsTypesList:[])
				});
			}else{
				setDataValues({...dataValues,agreementsList:(result.agreementsList?result.agreementsList:[])});
			}
			setAgreementsList(result.agreementsList?result.agreementsList.filter((agreement)=>((agreement.provider_name.toLowerCase().indexOf(inputValues.filter_providers.toLowerCase())>-1))||(inputValues.filter_providers===""))
																			.filter((agreement)=>(filter_active_inactive(agreement,inputValues.filter_active,inputValues.filter_inactive)))
			:[]);
			setDialogValues(defaultDialogValues);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if((oper==="list_products")||(oper==="save_product")||(oper==="delete_product")||(oper==="get_products_from_sub_agreement")) {
			setDataValues({...dataValues,agreementProductsList:(result.agreementProductsList?result.agreementProductsList:[])});							
			setInputValuesProducts(defaultInputValuesProducts);
			setAgreementProductsList(result.agreementProductsList?result.agreementProductsList
																					.filter((product)=>((product.product_name.toLowerCase().indexOf(inputValuesProducts.filter_products.toLowerCase())>-1))||(inputValuesProducts.filter_products===""))
																					.filter((product)=>((product.product_type_id===inputValuesProducts.filter_product_type)||(inputValuesProducts.filter_product_type==="")))
			:[]);
			if(result.agreementProductsList) {
				let tmp={};
				result.agreementProductsList.forEach(function(product) {
					tmp[product.id]=product.quantity;
				});
				setTableQuantities(tmp);
			}
			if(oper==="get_products_from_sub_agreement") {
				setDialogValues({...dialogValues,openFrameAgreements: false,titleFrameAgreements: ""});				
			}else{
				setDialogValues({...dialogValues,openListProducts: true,titleListProducts: "Lista de produse pentru contractul ["+currentAgreement.provider_name+"]",
												openAddEditProduct: false,titleAddEditProduct: ""
				});
			}
			oper="";
		}
		if(oper==="list_frame_agreements") {
			setDataValues({...dataValues,frameAgreementsList:(result.agreementsList?result.agreementsList:[])});							
			setDialogValues({...dialogValues,openFrameAgreements: true,titleFrameAgreements: "Lista contracte cadru pentru "+currentAgreement.provider_name});
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getSubAgreements";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="no">Numar*</label>
						<InputText name="no" id="no" style={{"width":"100%"}} value={inputValues.no} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={7} lg={7} className="field padding-med">
						<label htmlFor="provider_id">Furnizor*</label>
						<Dropdown name="provider_id" id="provider_id" style={{"width":"100%"}} filter options={dataValues.providersList} optionLabel="name" optionValue="id" value={inputValues.provider_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="seap_no">Numar SEAP</label>
						<InputText name="seap_no" id="seap_no" style={{"width":"100%"}} value={inputValues.seap_no} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="agreement_date">Data contract*</label>
						<Calendar name="agreement_date" id="agreement_date" style={{"width":"100%"}} value={inputValues.agreement_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="agreement_start_date">Data inceput*</label>
						<Calendar name="agreement_start_date" id="agreement_start_date" style={{"width":"100%"}} value={inputValues.agreement_start_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="agreement_stop_date">Data sfarsit*</label>
						<Calendar name="agreement_stop_date" id="agreement_stop_date" style={{"width":"100%"}} value={inputValues.agreement_stop_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={6} sm={6} md={3} lg={3} className="field padding-med">
						<label htmlFor="active">Activ</label>
						<Dropdown name="active" id="active" style={{"width":"100%"}} options={activeList} value={inputValues.active} onChange={(evt) => handleChange(evt)}/>
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const listProductsDialog = () => {
		return(
			<Dialog header={dialogValues.titleListProducts} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openListProducts:false})} className="responsive-dialog-big">
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={12} md={4} lg={4} xl={5} className="field padding-med">
							<InputText name="filter_products" id="filter_products" style={{"width":"100%"}} value={inputValuesProducts.filter_products} placeholder="Cauta produs..." onChange={(evt) => handleChangeProducts(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={12} md={3} lg={3} xl={3} className="field padding-med">
							<Dropdown name="filter_product_type" id="filter_product_type" style={{"width":"100%"}} filter options={dataValues.productsTypesList} placeholder="Filtrare categorie..." showClear optionLabel="name" optionValue="id" value={inputValuesProducts.filter_product_type} onChange={(evt) => handleChangeProducts(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={5} lg={5} xl={4} className="field padding-med text-right">
							<Button label="Preia produse din contract" icon="pi pi-arrow-right-arrow-left" className="p-button-sm p-button-primary p-button-raised" style={{"marginRight":"9px"}} onClick={(evt) => {handleButton(evt,"list_frame_agreements")}} disabled={(agreementProductsList.length===0?false:true)}/>
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"9px"}} onClick={(evt) => {handleButton(evt,"save_quantities")}}/>
							<Button label="Adauga produs" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add_product")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							id="centers_requests_products"
							value={agreementProductsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							rowGroupMode="rowspan"
							groupRowsBy="product_type"
							sortMode="single"
							sortField="product_type"
							sortOrder={1}
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="product_type" header="Tip produs" style={{"width":"25%","backgroundColor":"#FFFFFF"}} body={tableColTemplateProducts}></Column>
							<Column field="product_name" header="Produs" style={{"width":"48%"}}></Column>
							<Column field="unitary_price" header="Pret/U.M." style={{"width":"120px","textAlign":"center"}}></Column>
							<Column field="product_mu" header="U.M." style={{"width":"150px"}}></Column>
							<Column field="quantity" header="Cantitate" style={{"width":"60px","textAlign":"center"}} body={tableColTemplateProducts}></Column>
							<Column field="buttons" header="" style={{"width":"195px"}} body={tableColTemplateProducts}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const addEditProductDialog = () => {
		return(
			<Dialog header={dialogValues.titleAddEditProduct} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_type_id">Categorie*</label>
						<Dropdown name="product_type_id" id="product_type_id" style={{"width":"100%"}} filter options={dataValues.productsTypesList} showClear optionLabel="name" optionValue="id" value={inputValuesProducts.product_type_id} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="product_id">Produs* ({productsList.length} produse gasite)</label>
						<Dropdown name="product_id" id="product_id" style={{"width":"100%"}} filter options={productsList} optionLabel="name" optionValue="id" value={inputValuesProducts.product_id} onChange={(evt) => handleChangeProducts(evt)} disabled={(inputValuesProducts.product_type_id?false:false)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="product_mu_id">Unitate de masura*</label>
						<Dropdown name="product_mu_id" id="product_mu_id" style={{"width":"100%"}} options={dataValues.MUsList} filter value={inputValuesProducts.product_mu_id} optionLabel="name" optionValue="id" onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="unitary_price">Pret unitar*</label>
						<InputText name="unitary_price" id="unitary_price" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.unitary_price} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} className="field padding-med">
						<label htmlFor="quantity">Cantitate*</label>
						<InputText name="quantity" id="quantity" pattern="[0-9.]*" style={{"width":"100%"}} value={inputValuesProducts.quantity} onChange={(evt) => handleChangeProducts(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValuesProducts.observations} onChange={(evt) => handleChangeProducts(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
						<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
							{inputError.errorText}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_product")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEditProduct:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const cloneDialog = () => {
		return(
			<Dialog header={dialogValues.titleClone} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openClone:false})} className="responsive-dialog-med-small">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={2} lg={2} className="field padding-med">
						<label htmlFor="no">Numar*</label>
						<InputText name="no" id="no" style={{"width":"100%"}} value={inputValues.no} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={7} lg={7} className="field padding-med">
						<label htmlFor="provider_id">Furnizor*</label>
						<Dropdown name="provider_id" id="provider_id" style={{"width":"100%"}} filter options={dataValues.providersList} optionLabel="name" optionValue="id" value={inputValues.provider_id} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="seap_no">Numar SEAP</label>
						<InputText name="seap_no" id="seap_no" style={{"width":"100%"}} value={inputValues.seap_no} onChange={(evt) => handleChange(evt)}/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="agreement_date">Data contract*</label>
						<Calendar name="agreement_date" id="agreement_date" style={{"width":"100%"}} value={inputValues.agreement_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="agreement_start_date">Data inceput*</label>
						<Calendar name="agreement_start_date" id="agreement_start_date" style={{"width":"100%"}} value={inputValues.agreement_start_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={12} sm={12} md={3} lg={3} className="field padding-med">
						<label htmlFor="agreement_stop_date">Data sfarsit*</label>
						<Calendar name="agreement_stop_date" id="agreement_stop_date" style={{"width":"100%"}} value={inputValues.agreement_stop_date} onChange={(evt) => handleChange(evt)} locale="ro" showIcon/>
					</Grid>
					<Grid item xs={6} sm={6} md={3} lg={3} className="field padding-med">
						<label htmlFor="active">Activ</label>
						<Dropdown name="active" id="active" style={{"width":"100%"}} options={activeList} value={inputValues.active} onChange={(evt) => handleChange(evt)}/>
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<Checkbox inputId="replace_in_template" name="replace_in_template" value="replace_in_template"  onChange={(evt) => handleChange(evt)} checked={(inputValues.replace_in_template===1?true:false)} disabled={(inputValues.active===1?false:true)}/>
						<label htmlFor="replace_in_template" className={(inputValues.active===1?"ml-2":"ml-2 disabled_label")} style={{"marginBottom":"0px"}}>Inlocuieste contractul in sabloanele de necasare lunare</label>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<label htmlFor="observations">Observatii</label>
						<InputTextarea name="observations" id="observations" style={{"width":"100%","height":"90px"}} rows={5} cols={30} value={inputValues.observations} onChange={(evt) => handleChange(evt)}/>							
					</Grid>						
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_clone")} disabled={inputError.disableSave}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openClone:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const changeActiveDialog = () => {
		return(
			<Dialog header={dialogValues.titleChangeActive} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openChangeActive:false})} className="">
				<Grid container spacing={1} style={{"paddingTop":"12px","maxHeight":"72vh"}}>
					<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
						<p style={{"color":"#FF0000","fontWeight":"600","textAlign":"center"}}>La dezactivarea contractului va trebui sa verificati machetele de necesare lunare!</p>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Am inteles!" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openChangeActive:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const frameAgreementsDialog = () => {
		return(
			<Dialog header={dialogValues.titleFrameAgreements} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openFrameAgreements:false})} className="responsive-dialog-med-small">
				<div>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<DataTable
							value={dataValues.frameAgreementsList}
							scrollable
							scrollHeight="60vh"
							style={{"minHeight":"63vh"}}
							scrollDirection="both"
							stripedRows
							resizableColumns
							columnResizeMode="fit"
							emptyMessage="Nu exista inregistrari"
						>
							<Column field="no" header="Nr. contract" style={{"width":"18%"}} sortable></Column>
							<Column field="agreement_date_parsed" header="Data start" style={{"width":"15%","textAlign":"center"}}></Column>
							<Column field="year" header="Anul" style={{"width":"10%","textAlign":"center"}} sortable></Column>
							<Column field="observations" header="Observatii" style={{"width":"41%"}}></Column>
							<Column field="buttons" header="" style={{"width":"160px"}} body={tableColTemplateSubAgreements}></Column>
						</DataTable>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="no_date") {
			return(<span>{row_data.no}/{row_data.agreement_date_parsed}</span>);
		}
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza contract" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
					<Button label="Incarca" icon="pi pi-cloud-upload" tooltip="Incarca scan contract" className="p-button-sm p-button-raised" style={{"marginRight":"3px","display":"none"}} onClick={(evt) => handleButton(evt,"upload",row_data)}/>
					<Button label="Descarca" icon="pi pi-cloud-download" tooltip="Incarca scan contract" className="p-button-sm p-button-raised" style={{"marginRight":"3px","display":"none"}} onClick={(evt) => handleButton(evt,"download",row_data)}/>
					<Button label="Cloneaza" icon="pi pi-clone" tooltip="Duplicare" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"clone",row_data)}/>
					<Button label="Produse" icon="pi pi-list" tooltip="Produse" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"list_products",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge contract" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
				</span>
			);
		}
		if(column.field==="active") {
			if(row_data.active===1) {
				return(
					<span>
						<Tag severity="success" style={{"marginLeft":"12px"}} value="ACTIV"></Tag>
					</span>
				)
			}else{
				return(
					<span>
						<Tag severity="danger" style={{"marginLeft":"12px"}} value="INACTIV"></Tag>
					</span>
				)
			}
		}
	}

	const tableColTemplateProducts = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Editare" icon="pi pi-pencil" tooltip="Editeaza produs" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit_product",row_data)}/>
					<Button label="Stergere" icon="pi pi-trash" tooltip="Sterge produs" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete_product",row_data)}/>
				</span>
			);
		}
		if(column.field==="product_type") {
			return(
				<div className="flex align-items-center gap-2">
					<span className="font-bold">{row_data.product_type}</span>
				</div>
			);
		}		
		if(column.field==="quantity") {
			return <InputText name="quantity_table" id={row_data.id} className="p-inputtext_table" value={tableQuantities[row_data.id]} pattern="[0-9.]*" onChange={(evt) => handleChangeTable(evt,row_data.id)} onKeyDown={(evt) => handleFocusTable(evt)} />;			
		}
	}

	const tableColTemplateSubAgreements = (row_data,column) => {
		if(column.field==="buttons") {
			return(
				<span>
					<Button label="Preia produsele" icon="pi pi-plus" tooltip="Preia" className="p-button-sm p-button-raised" style={{}} onClick={(evt) => handleButton(evt,"get_products_from_sub_agreement",row_data)}/>
				</span>
			);
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
		if(what==="delete_product") {
			confirmDialog({
				message: "Sigur doriti stergerea? Dupa stergere verificati machetele de necesare lunare.",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={6} md={7} lg={7} xl={7} className="field padding-med">
							<InputText name="filter_providers" id="filter_providers" style={{"width":"60%","float":"left"}} value={inputValues.filter_providers} placeholder="Cauta furnizor..." onChange={(evt) => handleChange(evt)}/>						
							<div style={{"width":"30%","float":"right","marginTop":"9px"}}>
								<div style={{"width":"48%","float":"left"}}>
									<Checkbox inputId="filter_active" name="filter_active" value="active"  onChange={(evt) => handleChange(evt)} checked={(inputValues.filter_active===1?true:false)}/>
									<label htmlFor="filter_active" className="ml-2">Active</label>
								</div>
								<div style={{"width":"48%","float":"left"}}>
									<Checkbox inputId="filter_inactive" name="filter_inactive" value="inactive"  onChange={(evt) => handleChange(evt)} checked={(inputValues.filter_inactive===1?true:false)}/>
									<label htmlFor="filter_inactive" className="ml-2">Inactive</label>
								</div>
							</div>	
						</Grid>						
						<Grid item xs={12} sm={3} md={2} lg={2} xl={2} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{agreementsList.length} {(((agreementsList.length>1)||(agreementsList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={3} md={3} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adauga contract nou" icon="pi pi-plus-circle" className="p-button-sm p-button-primary p-button-raised" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={agreementsList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="no_date" header="Numar/data" style={{"flexGrow":"1","flexBasis":"150px"}} body={tableColTemplate} sortable></Column>
								<Column field="provider_name" header="Nume furnizor" style={{"flexGrow":"1","flexBasis":"330px"}} sortable></Column>
								<Column field="active" header="Stare" style={{"flexGrow":"0","flexBasis":"90px"}} body={tableColTemplate} sortable></Column>
								<Column field="reg_date_parsed" header="Data introducerii" style={{"flexGrow":"0","flexBasis":"180px"}} sortable></Column>
								<Column field="buttons" header="" style={{"flexGrow":"0","flexBasis":"387px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openListProducts && listProductsDialog()}
				{dialogValues.openAddEditProduct && addEditProductDialog()}
				{dialogValues.openClone && cloneDialog()}
				{dialogValues.openChangeActive && changeActiveDialog()}
				{dialogValues.openFrameAgreements && frameAgreementsDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default SubAgreements;

